import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetobhimashankarcabs() {



const cardData =
{
  keyword: 'Pune Airport to Bhimashankar Cabs',
  heading: 'Lotus Cab: Pune Airport to Bhimashankar Cabs',

  headingDescription: 'Lotus Cab provides reliable and professionally managed Pune Airport to Bhimashankar Cabs designed for devotees, families, senior citizens, and corporate travelers seeking a comfortable and safe journey directly from Pune Airport to the sacred Bhimashankar Jyotirlinga Temple. The route from Pune Airport to Bhimashankar covers approximately 125 km through scenic ghat sections and forest areas of the Western Ghats. This road requires skilled driving, familiarity with hill routes, and careful timing—especially during monsoon season and temple rush hours. Our airport pickup service ensures punctual arrival at Pune Airport based on real-time flight tracking so you never experience delays or waiting stress. Vehicles are fully air-conditioned, sanitized before every trip, and maintained specifically for long-distance comfort. Whether you require same-day darshan return, overnight pilgrimage travel, or weekend spiritual retreat, Lotus Cab provides flexible one-way and round-trip options. Transparent pricing, experienced highway drivers, comfortable seating, ample luggage space, and 24/7 booking support make us the preferred choice for airport to Bhimashankar temple travel. With Lotus Cab, your spiritual journey begins smoothly the moment you land in Pune.',

  top: 'Top Places to Visit Near Bhimashankar with Lotus Cab',

  "topPlaces": [
    {
      "title": "Bhimashankar Jyotirlinga Temple",
      "description": "One of the 12 sacred Jyotirlingas of Lord Shiva, Bhimashankar Temple is the main pilgrimage attraction. Surrounded by dense forest and hills, the temple offers a divine and peaceful atmosphere for darshan and aarti. Lotus Cab ensures timely temple arrival, especially for early morning rituals."
    },
    {
      "title": "Bhimashankar Wildlife Sanctuary",
      "description": "A protected forest area rich in biodiversity, ideal for nature lovers and trekking enthusiasts."
    },
    {
      "title": "Hanuman Lake",
      "description": "A serene lake near the temple offering peaceful surroundings and beautiful nature views."
    },
    {
      "title": "Gupt Bhimashankar",
      "description": "A hidden spiritual spot believed to be associated with Lord Shiva’s origin in the region."
    },
    {
      "title": "Nagphani Point",
      "description": "Also known as Cobra Point, this viewpoint offers breathtaking valley views."
    },
    {
      "title": "Sakshi Vinayak Temple",
      "description": "A small temple visited before Bhimashankar darshan for blessings."
    },
    {
      "title": "Ahupe Waterfalls",
      "description": "A scenic waterfall destination popular during monsoon."
    },
    {
      "title": "Karjat Valley View",
      "description": "Panoramic scenic view point ideal for photography."
    },
    {
      "title": "Shidi Ghat Trek Route",
      "description": "A popular trekking route for adventure seekers visiting Bhimashankar."
    },
    {
      "title": "Mulshi Lake (Enroute)",
      "description": "A beautiful stop during airport to Bhimashankar travel for short scenic break."
    }
  ],

  "services": [
    {
      "name": "Pune Airport to Bhimashankar Temple Cabs",
      "description": "Lotus Cab offers professionally managed Pune Airport to Bhimashankar Temple Cabs ensuring smooth pickup directly from arrival terminal with real-time flight tracking support. Our drivers coordinate based on landing time to avoid unnecessary waiting charges. The ghat road to Bhimashankar requires skilled handling and experienced driving, especially during monsoon and early morning fog conditions. Our chauffeurs are trained in hill-route safety and ensure comfortable, controlled driving through winding forest sections. Vehicles are fully air-conditioned, sanitized before departure, and equipped for long-distance comfort. Spacious seating and ample luggage capacity make travel convenient for families and senior citizens. We provide transparent fare structure including driver allowance details, toll clarity, and no hidden billing surprises. Whether you are planning same-day darshan or overnight stay, we offer flexible return scheduling. Our airport to temple cab service guarantees punctuality, safety, and peace of mind from pickup to drop."
    },
    {
      "name": "Bhimashankar Darshan Cab from Pune Airport",
      "description": "Specially designed darshan cab service for devotees landing at Pune Airport and heading directly to Bhimashankar Jyotirlinga. We ensure on-time temple arrival for aarti schedules and comfortable same-day return planning."
    },
    {
      "name": "Round Trip Cab Bhimashankar from Pune Airport",
      "description": "Flexible round-trip packages allowing devotees to complete darshan and return comfortably with driver waiting coordination."
    },
    {
      "name": "Same Day Bhimashankar Cab Pune Airport",
      "description": "Same-day return cab service designed for quick pilgrimage visits with optimized travel timing and safe highway driving."
    },
    {
      "name": "Luxury Cab Pune Airport to Bhimashankar",
      "description": "Premium luxury sedan and SUV options for executive travelers seeking superior comfort and smooth ride experience."
    },
    {
      "name": "SUV Taxi for Bhimashankar Trip",
      "description": "Spacious SUV vehicles ideal for group travel, family pilgrimage, and enhanced hill-road stability."
    },
    {
      "name": "Affordable Airport Taxi to Bhimashankar",
      "description": "Budget-friendly airport transfer packages with transparent per km pricing and no hidden charges."
    },
    {
      "name": "Online Airport Cab Booking Pune",
      "description": "Easy online booking with instant confirmation, 24/7 support, and flexible pickup coordination."
    }
  ],

  "tableData": [
    ["Pune Airport to Bhimashankar Temple Cabs", "Pune Airport to Bhimashankar Taxi"],
    ["Bhimashankar Darshan Cab from Pune Airport", "Airport Pickup to Bhimashankar Temple"],
    ["Pune Airport Outstation Cab", "Affordable Airport Taxi to Bhimashankar"],
    ["Luxury Cab Pune Airport to Bhimashankar", "SUV Taxi for Bhimashankar Trip"],
    ["Same Day Bhimashankar Cab Pune Airport", "Round Trip Cab Bhimashankar from Pune Airport"],
    ["Family Trip Cab to Bhimashankar", "Corporate Airport Transfer to Bhimashankar"],
    ["Online Airport Cab Booking Pune", ""]
  ],

  "whychoose": [
    {
      "WhyChooseheading": "Real-Time Flight Tracking",
      "WhyChoosedescription": "We monitor your flight arrival timing to ensure punctual airport pickup without waiting confusion."
    },
    {
      "WhyChooseheading": "Experienced Hill Drivers",
      "WhyChoosedescription": "Drivers trained specifically for ghat and forest road safety."
    },
    {
      "WhyChooseheading": "Transparent Pricing",
      "WhyChoosedescription": "Clear fare breakdown including tolls and driver allowance."
    },
    {
      "WhyChooseheading": "Comfortable AC Vehicles",
      "WhyChoosedescription": "Well-maintained and sanitized long-distance travel vehicles."
    },
    {
      "WhyChooseheading": "Flexible Return Scheduling",
      "WhyChoosedescription": "Choose same-day or overnight return options."
    },
    {
      "WhyChooseheading": "Family-Friendly Service",
      "WhyChoosedescription": "Spacious vehicles ideal for senior citizens and children."
    },
    {
      "WhyChooseheading": "Safe Night Travel",
      "WhyChoosedescription": "Verified drivers for secure highway travel."
    },
    {
      "WhyChooseheading": "24/7 Customer Support",
      "WhyChoosedescription": "Round-the-clock booking and travel assistance."
    }
  ]
}

const faqData = [
  { question: 'How far is Bhimashankar from Pune Airport?', answer: 'Approximately 125 km and takes around 3.5–4 hours depending on road and weather conditions.' },
  { question: 'Is same-day darshan possible?', answer: 'Yes, with early pickup planning same-day darshan is possible.' },
  { question: 'Do you track flights?', answer: 'Yes, we monitor flight timings for accurate pickup.' },
  { question: 'Are SUVs available?', answer: 'Yes, spacious SUV options are available.' },
  { question: 'Is night travel safe?', answer: 'Yes, drivers are experienced in hill routes.' },
  { question: 'Are vehicles AC?', answer: 'Yes, fully air-conditioned vehicles.' },
  { question: 'Is pricing transparent?', answer: 'Yes, no hidden charges.' },
  { question: 'Can I book online?', answer: 'Yes, instant booking confirmation available.' },
  { question: 'Do you provide corporate transfers?', answer: 'Yes, corporate airport to temple transfers available.' },
  { question: 'Is advance booking recommended?', answer: 'Yes, especially during festival season.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vivek Sharma',
    feedback: 'Landed at Pune Airport early morning and directly headed to Bhimashankar. Driver was punctual, professional, and handled ghat roads very safely. Comfortable ride and transparent fare. Highly recommended.',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Anjali Deshpande',
    feedback: 'Booked family darshan trip from airport. Spacious SUV, smooth driving, and timely temple arrival made our spiritual journey peaceful and stress-free.',
    rating: 5
  }
];















































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Airport to Bhimashankar Cabs",
  "image": "https://lotuscab.com/assets/images/pune-airport-to-bhimashankar-cabs.jpg", 
  "description": "Lotus Cab provides Pune Airport to Bhimashankar cabs for darshan, family trips, corporate transfers, and same day round trips. Book affordable sedan, SUV, and luxury cabs with professional drivers for a comfortable journey from Pune Airport.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5800"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3199",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pune-airport-to-bhimashankar-cabs"
  }
};






  return (
    <div>
      

<Helmet>
  <title>Contact: +91 8767592195 | Pune Airport to Bhimashankar Cabs | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book Pune Airport to Bhimashankar cabs with Lotus Cab. Affordable one way & round trip taxi for darshan, family & corporate trips. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune Airport to Bhimashankar Temple Cabs, Pune Airport to Bhimashankar Taxi, Bhimashankar Darshan Cab from Pune Airport, Airport Pickup to Bhimashankar Temple, Pune Airport Outstation Cab, Affordable Airport Taxi to Bhimashankar, Luxury Cab Pune Airport to Bhimashankar, SUV Taxi for Bhimashankar Trip, Same Day Bhimashankar Cab Pune Airport, Round Trip Cab Bhimashankar from Pune Airport, Family Trip Cab to Bhimashankar, Corporate Airport Transfer to Bhimashankar, Online Airport Cab Booking Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/11.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetobhimashankarcabs;